import { useMemo } from "react";
import { useIntl } from "gatsby-plugin-intl";

// eslint-disable-next-line import/prefer-default-export
export const useDirection = () => {
  const { locale } = useIntl();
  const dir = useMemo(() => (locale === "ar" ? "rtl" : "ltr"), [locale]);

  return dir;
};
